const isMac = () => {
  return /macintosh|mac os x/i.test(navigator.userAgent)
}

const isWindows = () => {
  return /windows|win32/i.test(navigator.userAgent)
}

let CryptoAgent = {}

if (isWindows()) {
  try {
    const eDiv = document.createElement('div')
    eDiv.style.height = 0
    if (navigator.appName.indexOf('Internet') >= 0 || navigator.appVersion.indexOf('Trident') >= 0) {
      if (window.navigator.cpuClass == 'x86') {
        eDiv.innerHTML =
          '<object id="CryptoAgent" codebase="CryptoKit.YYRL.x86.cab" classid="clsid:0584A9E2-6E18-4888-ACC3-824C8630954B" ></object>'
      } else {
        eDiv.innerHTML =
          '<object id="CryptoAgent" codebase="CryptoKit.YYRL.x64.cab" classid="clsid:4B4AD963-28B3-4C2C-96F1-95ABA7110547" ></object>'
      }
    } else {
      eDiv.innerHTML =
        '<embed id="CryptoAgent" type="application/npCryptoKit.YYRL.x86" style="height: 0px; width: 0px">'
    }
    document.body.appendChild(eDiv)
  } catch (e) {
    console.log(e)
  }
  CryptoAgent = document.getElementById('CryptoAgent')
}

if (isMac()) {
  //TODO  mac待处理
}

const Ukey = {}

Ukey.selectCertificate = (
  bstrSubjectDNFilter = '',
  bstrIssuerDNFilter = '',
  bstrSerialNumFilter = '',
  cspNameList = ''
) => {
  return new Promise((resolve, reject) => {
    try {
      const bSelectCertResult = CryptoAgent.SelectCertificate(
        bstrSubjectDNFilter,
        bstrIssuerDNFilter,
        bstrSerialNumFilter,
        cspNameList
      )
      if (!bSelectCertResult) {
        reject(getError())
        return
      }
      resolve(bSelectCertResult)
    } catch (ee) {
      reject(getError())
    }
  })
}

Ukey.signOn = (bstrSourceData = '', bstrHashAlg = 'SHA-1', bWithSourceData = true) => {
  return new Promise((resolve, reject) => {
    try {
      // SHA-256/SHA-1
      const sigure = CryptoAgent.SignMsgPKCS7(bstrSourceData, bstrHashAlg, bWithSourceData)
      if (!sigure) {
        reject(getError())
        return
      }
      resolve(sigure)
    } catch (e) {
      reject(getError())
    }
  })
}

/*
 infotypeId:
 "SubjectDN"           //证书主题 DN
 "SubjectCN"           //证书主题 CN
 "IssuerDN"            //颁发者 DN
 "SerialNumber"        //证书序列号
 "CSPName"             //证书对应的 CSP 名称
 "CertType"            //证书类型;SM2 或 RSA
 * */
Ukey.getCerInfo = (bstrInfoType = 'SubjectCN') => {
  return new Promise((resolve, reject) => {
    try {
      const infoContent = CryptoAgent.GetSignCertInfo(bstrInfoType)
      if (!infoContent) {
        reject(getError())
        return
      }
      resolve(infoContent)
    } catch (e) {
      reject(getError())
    }
  })
}

Ukey.getSubjectCN = () => {
  return new Promise(async (resolve, reject) => {
    try {
      let subjectDN = await Ukey.getCerInfo('SubjectCN')
      subjectDN = subjectDN.split('@')[1]
      resolve(subjectDN)
    } catch (e) {
      reject(getError())
    }
  })
}

Ukey.driveUrl = () => {
  return 'https://statics.ekuaibao.com/public/npCryptokit.zip'
}

function getError() {
  return CryptoAgent.GetLastErrorDesc()
}

global.Ukey = Ukey
global.isMac = isMac
